class DefaultValuesUtils {
  static ROUTES = Object.freeze({
    // ***---- Main Menu Routes ----***
    0: "/tickets?tab=open"
    , 1: "/tickets?tab=closed"

    , 2: "/contacts"
    , 3: "/labels"

    , 4: "/dashboard"
    , 5: "/attendantsDashboard"
    , 6: "/ticketsDashboard"
    , 7: "/ratingsDashboard"
    , 8: "/queueOverridesDashboard"
    , 9: "/groupsDashboard"
    , 10: "/internalChatsDashboard"
    , 11: "/internalGroupsDashboard"

    , 12: "/pixMessages"
    , 13: "/automaticMessages"
    , 14: "/quickAnswers"
    , 15: "/starredMessages"

    , 16: "/users"

    , 17: "/connections"

    , 18: "/businessHours"

    , 19: "/queues"
    , 20: "/categories"
    , 21: "/subqueues"
    , 22: "/flow"

    , 23: "/myProfile"

    , 24: "/dispatchManager"
    , 25: "/dispatchContactsManager"

    , 26: "/management"

    , 27: "/settings"
    , 28: "/bulkActions"

    // ***---- General Routes ----***
    , 100: "/tickets"

    , 101: "/login"
    , 102: "/loginGroup"
    , 103: "/passwordReset"
    , 104: "/passwordResetValidation"
    , 105: "/passwordResetDefinition"
    , 106: "/expiredPasswordReset"

    , 998: "/404"
    , 999: "/privacyPolicy"
  });

  static TIMEZONES = Object.freeze({
    "GMT-2": "America/Noronha"
    , "GMT-3": "America/Sao_Paulo"
    , "GMT-4": "America/Cuiaba"
    , "GMT-5": "America/Rio_Branco"
  });

  static MESSAGE_TYPES = Object.freeze({
    convertedTypes: {
      application: "application"
      , audio: "audio"
      , button: "button"
      , buttonCreation: "button_creation"
      , buttonResponse: "button_response"
      , call: "call"
      , chat: "chat"
      , document: "document"
      , ephemeralSetting: "ephemeral_setting"
      , event: "event"
      , groupInvite: "group_invite"
      , image: "image"
      , list: "list"
      , listCreation: "list_creation"
      , listResponse: "list_response"
      , location: "location"
      , metaAiInvoke: "meta_ai_invoke"
      , multiVcard: "multi_vcard"
      , notification: "notification"
      , pix: "pix"
      , pollCreation: "poll_creation"
      , ptv: "ptv"
      , sticker: "sticker"
      , template: "template"
      , templateButtonReply: "template_button_reply"
      , transferenceObservation: "transference_observation"
      , vcard: "vcard"
      , viewOnce: "viewOnce"
      , video: "video"
    }
  });

  static SPECIAL_NAMES = Object.freeze({
    whatsapp: "WhatsApp Official ✔️"
    , metaAi: "Meta AI"
  });

  static JIDS = Object.freeze({
    lid: "@lid"
    , chat: "@s.whatsapp.net"
    , group: "@g.us"
    , allGroupMembers: "all"
  });

  static ADDRESSING_MODES = Object.freeze({
    lid: "lid"
    , pn: "pn"
  });

  static TEXT_SIZES = Object.freeze({
    pixAdditionalInfo: 250
    , queueOverrideReason: { min: 10, max: 250 }
    , inputTextArea: 64_000
  });

  static URLS = Object.freeze({
    officialApi: {
      coupon: "https://www.whatsapp.com/coupon"
    }
  });

  static TEMPLATE_TYPES = Object.freeze({
    fourRowTemplate: "fourRowTemplate"
    , hydratedFourRowTemplate: "hydratedFourRowTemplate"
    , hydratedTemplate: "hydratedTemplate"
    , interactiveMessageTemplate: "interactiveMessageTemplate"
  });

  static DEFAULT_TEMPLATE_TYPES = Object.freeze({
    defaultTemplate: "defaultTemplate"
  });
  
  static ADS = Object.freeze({
    adsConversionFrom: "fb.me"
  });

  static DATE_LIMITS = Object.freeze({
    queueOverrideRequestUserFetch: 1000 * 60 * 30 // 30 minutes
  });

  static RETRIES = Object.freeze({
    defaultAttempts: 5
    , defaultDelayMs: 100
  });

  static MANAGER_TENANTS = Object.freeze(["1", "74"]);

  static ALLOWED_COMPANY_LOGO_MIMETYPES = Object.freeze(["image/png", "image/jpeg"]);

  static REGEX = Object.freeze({
    user: {
      name: /[^a-zA-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s_@-]/g
      , email: /[^a-zA-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ._@-]/g
    }
  });

};

export default DefaultValuesUtils;
